import { AbstractModel } from '@patsnap/tahiti-core';
import type { AutoMountModel, AutoMountState } from '../auto-mount-manager';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

/**
 * 自动挂载数据模型实现
 */
@injectable()
export class AutoMountModelImpl extends AbstractModel<AutoMountState> implements AutoMountModel {
    protected _modelData: AutoMountState = {
        loopForNames: [],
        componentMap: {},
        attrMap: {},
    };

    dispose(): void {
        this._modelData = {
            loopForNames: [],
            componentMap: {},
            attrMap: {},
        };
    }
}
